// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.intro[data-v-a9cda936]{ font-size: 15px; color:var(--main-gray-5);\n}\n.content[data-v-a9cda936]{ font-size: 13px; color:var(--main-gray-6); margin-top: 20px;\n}\n.roadmap-item[data-v-a9cda936]{\n  background: #fff; border:1px solid var(--main-gray-2); border-radius: 15px;\n  padding: 20px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
